import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { useAuth } from '../../context/AuthContext';
import { InfoBanner } from '../../components/ui/info-banner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Checkbox } from '../../components/ui/checkbox';
import { toast } from 'sonner';
import { 
  Plus, 
  Search, 
  Trash2, 
  Loader2,
  Building2, 
  Package, 
  Pencil,
  Phone,
  MapPin,
  User,
  Calendar,
  ChevronDown,
  ChevronRight,
  ShoppingCart,
  DollarSign,
  TrendingUp,
  ArrowUpDown,
  Download,
  Mail,
  FileText,
  Eye,
  CreditCard
} from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import * as XLSX from 'xlsx';

const API = process.env.REACT_APP_BACKEND_URL;

const PurchasingGlobalData = ({ readOnly = false }) => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('cari');
  
  // Cari Hesap State
  const [cariHesaplar, setCariHesaplar] = useState([]);
  const [cariSearch, setCariSearch] = useState('');
  const [cariModal, setCariModal] = useState(false);
  const [cariForm, setCariForm] = useState({ 
    name: '', 
    city: '', 
    phone: '', 
    vergi_no: '', 
    yetkili: '', 
    adres: '', 
    email: '',
    iban: '',
    hesap_sahibi: ''
  });
  const [cariLoading, setCariLoading] = useState(false);
  const [cariSort, setCariSort] = useState({ field: 'name', direction: 'asc' });
  
  // Cari Hesap Detay Modal
  const [cariDetailModal, setCariDetailModal] = useState(false);
  const [selectedCari, setSelectedCari] = useState(null);
  
  // Stok Kartı State
  const [stokKartlari, setStokKartlari] = useState([]);
  const [stokSearch, setStokSearch] = useState('');
  const [stokModal, setStokModal] = useState(false);
  const [stokForm, setStokForm] = useState({ 
    product_name: '', 
    model: '', 
    features: '', 
    unit: 'adet', 
    branch_min_usage: {}, // Şube bazlı minimum stok
    branch_max_usage: {} // Şube bazlı maksimum kullanım
  });
  const [stokLoading, setStokLoading] = useState(false);
  const [stokSort, setStokSort] = useState({ field: 'product_name', direction: 'asc' });
  const [branches, setBranches] = useState([]); // Şube listesi
  
  // Edit States
  const [editCariModal, setEditCariModal] = useState(false);
  const [editCariForm, setEditCariForm] = useState({ 
    id: '', 
    name: '', 
    city: '', 
    phone: '', 
    vergi_no: '', 
    yetkili: '', 
    adres: '', 
    email: '',
    iban: '',
    hesap_sahibi: ''
  });
  const [editStokModal, setEditStokModal] = useState(false);
  const [editStokForm, setEditStokForm] = useState({ 
    id: '', 
    product_name: '', 
    model: '', 
    features: '', 
    unit: 'adet', 
    branch_min_usage: {}, // Şube bazlı minimum stok
    branch_max_usage: {} // Şube bazlı maksimum kullanım
  });
  
  // Expanded cari rows state
  const [expandedCari, setExpandedCari] = useState({});
  const [expandedOrders, setExpandedOrders] = useState({}); // Sipariş detayları için
  const [cariGirisler, setCariGirisler] = useState({}); // Cari hesaba ait stok girişleri
  const [cariGirislerLoading, setCariGirislerLoading] = useState({});
  
  // Expanded stok rows state
  const [expandedStok, setExpandedStok] = useState({});
  const [stokMovements, setStokMovements] = useState({});
  const [stokMovementsLoading, setStokMovementsLoading] = useState({});
  const [movementSort, setMovementSort] = useState({ field: 'date', direction: 'desc' });

  // Bulk selection states
  const [selectedCariItems, setSelectedCariItems] = useState([]);
  const [selectedStokItems, setSelectedStokItems] = useState([]);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);

  // Filtreler için state'ler
  const [cariFilterBranch, setCariFilterBranch] = useState(''); // Cari Hesap şube filtresi
  const [cariFilterType, setCariFilterType] = useState(''); // Cari Hesap giriş/çıkış filtresi
  const [stokFilterBranch, setStokFilterBranch] = useState(''); // Stok Kartı şube filtresi
  const [stokFilterType, setStokFilterType] = useState(''); // Stok Kartı giriş/çıkış filtresi

  const token = localStorage.getItem('fortis_token');
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  // Bulk selection functions
  const toggleCariSelection = (itemId) => {
    setSelectedCariItems(prev => 
      prev.includes(itemId) 
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  const toggleStokSelection = (itemId) => {
    setSelectedStokItems(prev => 
      prev.includes(itemId) 
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  const toggleSelectAllCari = (items) => {
    const itemIds = items.map(i => i.id);
    const allSelected = itemIds.every(id => selectedCariItems.includes(id));
    
    if (allSelected) {
      setSelectedCariItems(prev => prev.filter(id => !itemIds.includes(id)));
    } else {
      setSelectedCariItems(prev => [...new Set([...prev, ...itemIds])]);
    }
  };

  const toggleSelectAllStok = (items) => {
    const itemIds = items.map(i => i.id);
    const allSelected = itemIds.every(id => selectedStokItems.includes(id));
    
    if (allSelected) {
      setSelectedStokItems(prev => prev.filter(id => !itemIds.includes(id)));
    } else {
      setSelectedStokItems(prev => [...new Set([...prev, ...itemIds])]);
    }
  };

  const handleBulkDeleteCari = async () => {
    if (selectedCariItems.length === 0) {
      toast.error('Lütfen silmek için kayıt seçin');
      return;
    }
    
    if (!window.confirm(`${selectedCariItems.length} cari hesabı kalıcı olarak silmek istediğinizden emin misiniz?`)) {
      return;
    }
    
    setBulkDeleteLoading(true);
    try {
      const response = await fetch(`${API}/api/global/cari-hesaplar/bulk-delete`, {
        method: 'DELETE',
        headers,
        body: JSON.stringify({ cari_ids: selectedCariItems })
      });
      
      if (response.ok) {
        const result = await response.json();
        toast.success(`${result.deleted_count || selectedCariItems.length} kayıt silindi`);
        setSelectedCariItems([]);
        fetchCariHesaplar();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Kayıtlar silinemedi');
      }
    } catch (error) {
      console.error('Toplu silme hatası:', error);
      toast.error('Kayıtlar silinirken hata oluştu');
    } finally {
      setBulkDeleteLoading(false);
    }
  };

  const handleBulkDeleteStok = async () => {
    if (selectedStokItems.length === 0) {
      toast.error('Lütfen silmek için kayıt seçin');
      return;
    }
    
    if (!window.confirm(`${selectedStokItems.length} stok kartını kalıcı olarak silmek istediğinizden emin misiniz?`)) {
      return;
    }
    
    setBulkDeleteLoading(true);
    try {
      const response = await fetch(`${API}/api/global/stok-kartlari/bulk-delete`, {
        method: 'DELETE',
        headers,
        body: JSON.stringify({ stok_ids: selectedStokItems })
      });
      
      if (response.ok) {
        const result = await response.json();
        toast.success(`${result.deleted_count || selectedStokItems.length} kayıt silindi`);
        setSelectedStokItems([]);
        fetchStokKartlari();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Kayıtlar silinemedi');
      }
    } catch (error) {
      console.error('Toplu silme hatası:', error);
      toast.error('Kayıtlar silinirken hata oluştu');
    } finally {
      setBulkDeleteLoading(false);
    }
  };

  // Fetch Global Cari Hesaplar
  const fetchCariHesaplar = useCallback(async () => {
    setCariLoading(true);
    try {
      const response = await fetch(`${API}/api/global/cari-hesaplar`, { headers });
      if (response.ok) {
        const data = await response.json();
        setCariHesaplar(data);
      }
    } catch (error) {
      console.error('Cari hesaplar yüklenirken hata:', error);
      toast.error('Cari hesaplar yüklenirken hata oluştu');
    } finally {
      setCariLoading(false);
    }
  }, []);

  // Fetch Global Stok Kartları
  const fetchStokKartlari = useCallback(async () => {
    setStokLoading(true);
    try {
      const response = await fetch(`${API}/api/global/stok-kartlari`, { headers });
      if (response.ok) {
        const data = await response.json();
        setStokKartlari(data);
      }
    } catch (error) {
      console.error('Stok kartları yüklenirken hata:', error);
      toast.error('Stok kartları yüklenirken hata oluştu');
    } finally {
      setStokLoading(false);
    }
  }, []);

  // Fetch Branches
  const fetchBranches = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/branches`, { headers });
      if (response.ok) {
        const data = await response.json();
        setBranches(data);
      }
    } catch (error) {
      console.error('Şubeler yüklenirken hata:', error);
    }
  }, []);

  useEffect(() => {
    fetchCariHesaplar();
    fetchStokKartlari();
    fetchBranches();
  }, [fetchCariHesaplar, fetchStokKartlari, fetchBranches]);

  // Stok Hareketlerini Çek
  const fetchStokMovements = async (stokKartId, productName) => {
    setStokMovementsLoading(prev => ({ ...prev, [stokKartId]: true }));
    try {
      // Tüm şubelerdeki stok girişleri ve çıkışlarını çek
      const [girişlerRes, çıkışlarRes] = await Promise.all([
        fetch(`${API}/api/global/stok-girisleri?product_name=${encodeURIComponent(productName)}`, { headers }),
        fetch(`${API}/api/global/stok-cikislari?product_name=${encodeURIComponent(productName)}`, { headers })
      ]);
      
      let movements = [];
      
      if (girişlerRes.ok) {
        const girişler = await girişlerRes.json();
        girişler.forEach(g => {
          movements.push({
            id: g.id,
            date: g.created_at,
            type: 'giriş',
            quantity: g.quantity,
            unit: g.unit,
            source: g.source || g.cari_hesap_name || 'Bilinmiyor',
            branch: g.branch_name || '-',
            description: g.description || '-',
            created_by: g.created_by_name || '-'
          });
        });
      }
      
      if (çıkışlarRes.ok) {
        const çıkışlar = await çıkışlarRes.json();
        çıkışlar.forEach(c => {
          movements.push({
            id: c.id,
            date: c.created_at,
            type: 'çıkış',
            quantity: c.quantity,
            unit: c.unit,
            source: c.source || c.recipient_company || c.recipient_name || 'Bilinmiyor',
            branch: c.branch_name || '-',
            description: c.description || '-',
            created_by: c.created_by_name || '-'
          });
        });
      }
      
      // Tarihe göre sırala (yeniden eskiye)
      movements.sort((a, b) => new Date(b.date) - new Date(a.date));
      
      setStokMovements(prev => ({ ...prev, [stokKartId]: movements }));
    } catch (error) {
      console.error('Stok hareketleri yüklenirken hata:', error);
      toast.error('Stok hareketleri yüklenemedi');
    } finally {
      setStokMovementsLoading(prev => ({ ...prev, [stokKartId]: false }));
    }
  };

  // Stok satırını genişlet/daralt
  const toggleStokExpansion = (stokId, productName) => {
    setExpandedStok(prev => {
      const isExpanded = prev[stokId];
      if (!isExpanded) {
        // Genişletiliyorsa hareketleri çek
        fetchStokMovements(stokId, productName);
      }
      return { ...prev, [stokId]: !isExpanded };
    });
  };

  // Hareket tablosu sıralaması
  const handleMovementSort = (field) => {
    setMovementSort(prev => ({
      field,
      direction: prev.field === field && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // Sıralanmış hareketleri getir
  const getSortedMovements = (movements) => {
    if (!movements) return [];
    return [...movements].sort((a, b) => {
      let aVal = a[movementSort.field];
      let bVal = b[movementSort.field];
      
      if (movementSort.field === 'date') {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      } else if (movementSort.field === 'quantity') {
        aVal = Number(aVal) || 0;
        bVal = Number(bVal) || 0;
      }
      
      if (aVal < bVal) return movementSort.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return movementSort.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  // Cari Hesap CRUD
  const handleCreateCari = async () => {
    if (!cariForm.name.trim()) {
      toast.error('Cari hesap adı zorunludur');
      return;
    }
    try {
      const response = await fetch(`${API}/api/global/cari-hesaplar`, {
        method: 'POST',
        headers,
        body: JSON.stringify(cariForm)
      });
      if (response.ok) {
        toast.success('Cari hesap eklendi');
        setCariModal(false);
        setCariForm({ name: '', city: '', phone: '', vergi_no: '', yetkili: '', adres: '', email: '', iban: '', hesap_sahibi: '' });
        fetchCariHesaplar();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch (error) {
      toast.error('Cari hesap eklenirken hata oluştu');
    }
  };

  const handleUpdateCari = async () => {
    if (!editCariForm.name.trim()) {
      toast.error('Cari hesap adı zorunludur');
      return;
    }
    try {
      const response = await fetch(`${API}/api/global/cari-hesaplar/${editCariForm.id}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(editCariForm)
      });
      if (response.ok) {
        toast.success('Cari hesap güncellendi');
        setEditCariModal(false);
        fetchCariHesaplar();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch (error) {
      toast.error('Cari hesap güncellenirken hata oluştu');
    }
  };

  const handleDeleteCari = async (id) => {
    if (!window.confirm('Bu cari hesabı silmek istediğinizden emin misiniz?')) return;
    try {
      const response = await fetch(`${API}/api/global/cari-hesaplar/${id}`, {
        method: 'DELETE',
        headers
      });
      if (response.ok) {
        toast.success('Cari hesap silindi');
        fetchCariHesaplar();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch (error) {
      toast.error('Cari hesap silinirken hata oluştu');
    }
  };

  // Stok Kartı CRUD
  const handleCreateStok = async () => {
    if (!stokForm.product_name.trim()) {
      toast.error('Ürün adı zorunludur');
      return;
    }
    try {
      // branch_max_usage değerlerini integer'a çevir
      const branchMaxUsage = {};
      Object.keys(stokForm.branch_max_usage || {}).forEach(branchId => {
        const value = stokForm.branch_max_usage[branchId];
        if (value && value !== '') {
          branchMaxUsage[branchId] = parseInt(value);
        }
      });
      
      // branch_min_usage değerlerini integer'a çevir
      const branchMinUsage = {};
      Object.keys(stokForm.branch_min_usage || {}).forEach(branchId => {
        const value = stokForm.branch_min_usage[branchId];
        if (value && value !== '') {
          branchMinUsage[branchId] = parseInt(value);
        }
      });
      
      const response = await fetch(`${API}/api/global/stok-kartlari`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...stokForm,
          branch_min_usage: branchMinUsage,
          branch_max_usage: branchMaxUsage
        })
      });
      if (response.ok) {
        toast.success('Stok kartı eklendi');
        setStokModal(false);
        setStokForm({ product_name: '', model: '', features: '', unit: 'adet', branch_min_usage: {}, branch_max_usage: {} });
        fetchStokKartlari();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch (error) {
      toast.error('Stok kartı eklenirken hata oluştu');
    }
  };

  const handleUpdateStok = async () => {
    if (!editStokForm.product_name.trim()) {
      toast.error('Ürün adı zorunludur');
      return;
    }
    try {
      // branch_max_usage değerlerini integer'a çevir
      const branchMaxUsage = {};
      Object.keys(editStokForm.branch_max_usage || {}).forEach(branchId => {
        const value = editStokForm.branch_max_usage[branchId];
        if (value && value !== '') {
          branchMaxUsage[branchId] = parseInt(value);
        }
      });
      
      // branch_min_usage değerlerini integer'a çevir
      const branchMinUsage = {};
      Object.keys(editStokForm.branch_min_usage || {}).forEach(branchId => {
        const value = editStokForm.branch_min_usage[branchId];
        if (value && value !== '') {
          branchMinUsage[branchId] = parseInt(value);
        }
      });
      
      const response = await fetch(`${API}/api/global/stok-kartlari/${editStokForm.id}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({
          ...editStokForm,
          branch_min_usage: branchMinUsage,
          branch_max_usage: branchMaxUsage
        })
      });
      if (response.ok) {
        toast.success('Stok kartı güncellendi');
        setEditStokModal(false);
        fetchStokKartlari();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch (error) {
      toast.error('Stok kartı güncellenirken hata oluştu');
    }
  };

  const handleDeleteStok = async (id) => {
    if (!window.confirm('Bu stok kartını silmek istediğinizden emin misiniz?')) return;
    try {
      const response = await fetch(`${API}/api/global/stok-kartlari/${id}`, {
        method: 'DELETE',
        headers
      });
      if (response.ok) {
        toast.success('Stok kartı silindi');
        fetchStokKartlari();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch (error) {
      toast.error('Stok kartı silinirken hata oluştu');
    }
  };

  // Sıralama fonksiyonları
  const handleCariSort = (field) => {
    setCariSort(prev => ({
      field,
      direction: prev.field === field && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleStokSort = (field) => {
    setStokSort(prev => ({
      field,
      direction: prev.field === field && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // Filtered and sorted data
  const filteredCari = cariHesaplar
    .filter(c => 
      c.name?.toLowerCase().includes(cariSearch.toLowerCase()) ||
      c.city?.toLowerCase().includes(cariSearch.toLowerCase())
    )
    .sort((a, b) => {
      const aVal = a[cariSort.field] || '';
      const bVal = b[cariSort.field] || '';
      if (cariSort.field === 'order_count' || cariSort.field === 'total_items' || cariSort.field === 'total_amount') {
        return cariSort.direction === 'asc' ? (aVal - bVal) : (bVal - aVal);
      }
      return cariSort.direction === 'asc' 
        ? String(aVal).localeCompare(String(bVal), 'tr')
        : String(bVal).localeCompare(String(aVal), 'tr');
    });

  const filteredStok = stokKartlari
    .filter(s => 
      s.product_name?.toLowerCase().includes(stokSearch.toLowerCase()) ||
      s.model?.toLowerCase().includes(stokSearch.toLowerCase())
    )
    .sort((a, b) => {
      const aVal = a[stokSort.field] || '';
      const bVal = b[stokSort.field] || '';
      if (stokSort.field === 'created_at') {
        return stokSort.direction === 'asc' 
          ? new Date(aVal) - new Date(bVal)
          : new Date(bVal) - new Date(aVal);
      }
      return stokSort.direction === 'asc' 
        ? String(aVal).localeCompare(String(bVal), 'tr')
        : String(bVal).localeCompare(String(aVal), 'tr');
    });

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('tr-TR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('tr-TR') + ' ' + date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    } catch {
      return dateStr;
    }
  };

  const formatCurrency = (value) => {
    if (value === 0 || value === null || value === undefined) return '-';
    return new Intl.NumberFormat('tr-TR', { 
      style: 'currency', 
      currency: 'TRY',
      minimumFractionDigits: 2 
    }).format(value);
  };

  // Excel Export Fonksiyonları
  const exportCariToExcel = () => {
    const data = [];
    
    filteredCari.forEach(cari => {
      // Cari Hesap Ana Satırı
      data.push({
        'Seviye': 'CARİ HESAP',
        'Cari Hesap Adı': cari.name || '-',
        'Sipariş Adet': `${cari.order_count || 0} sipariş`,
        'Gelen Adet': `${cari.total_items || 0} ürün`,
        'Eksik': '',
        'Birim': cari.city || '-',
        'Birim Fiyat (₺)': cari.phone || '-',
        'Toplam (₺)': cari.total_spent || 0
      });
      
      // Siparişler
      if (cari.orders && cari.orders.length > 0) {
        cari.orders.forEach((order, orderIdx) => {
          // Sipariş Satırı
          data.push({
            'Seviye': `  └ SİPARİŞ ${orderIdx + 1}`,
            'Cari Hesap Adı': order.date ? formatDateTime(order.date) : '-',
            'Sipariş Adet': order.item_count || 0,
            'Gelen Adet': '',
            'Eksik': '',
            'Birim': order.branch_name || '-',
            'Birim Fiyat (₺)': order.status || '-',
            'Toplam (₺)': order.total || 0
          });
          
          // Ürün Detayları
          if (order.items && order.items.length > 0) {
            order.items.forEach((item, itemIdx) => {
              const orderedQty = parseFloat(item.quantity || item.miktar || 0);
              const receivedQty = parseFloat(item.received_quantity || 0);
              const missingQty = orderedQty - receivedQty;
              const unitPrice = parseFloat(item.purchase_price || item.unit_price || 0);
              const itemTotal = orderedQty * unitPrice;
              
              data.push({
                'Seviye': `      └ Ürün ${itemIdx + 1}`,
                'Cari Hesap Adı': item.product_name || item.name || '-',
                'Sipariş Adet': orderedQty,
                'Gelen Adet': receivedQty,
                'Eksik': missingQty > 0 ? missingQty : (receivedQty > 0 ? 'Tamam' : '-'),
                'Birim': item.unit || item.birim || 'adet',
                'Birim Fiyat (₺)': unitPrice || '-',
                'Toplam (₺)': itemTotal || 0
              });
            });
          }
        });
      }
      
      // Boş satır ayırıcı
      data.push({
        'Seviye': '',
        'Cari Hesap Adı': '',
        'Sipariş Adet': '',
        'Gelen Adet': '',
        'Eksik': '',
        'Birim': '',
        'Birim Fiyat (₺)': '',
        'Toplam (₺)': ''
      });
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cari Hesaplar');
    
    // Kolon genişlikleri
    ws['!cols'] = [
      { wch: 20 }, // Seviye
      { wch: 25 }, // Cari Hesap Adı / Ürün Adı
      { wch: 12 }, // Sipariş Adet
      { wch: 12 }, // Gelen Adet
      { wch: 10 }, // Eksik
      { wch: 10 }, // Birim
      { wch: 14 }, // Birim Fiyat
      { wch: 14 }  // Toplam
    ];

    XLSX.writeFile(wb, `Cari_Hesaplar_Detayli_${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Cari hesaplar detaylı Excel olarak indirildi');
  };

  const exportStokToExcel = () => {
    const data = [];
    
    filteredStok.forEach(stok => {
      // Stok Kartı Ana Satırı
      data.push({
        'Seviye': 'STOK KARTI',
        'Ürün Adı': stok.product_name || '-',
        'Model': stok.model || '-',
        'Birim': stok.unit || '-',
        'Ekleyen': stok.created_by_name || '-',
        'Tarih': stok.created_at ? formatDate(stok.created_at) : '-'
      });
      
      // Şube bazlı Min/Max değerleri
      const allBranchIds = new Set([
        ...Object.keys(stok.branch_min_usage || {}),
        ...Object.keys(stok.branch_max_usage || {})
      ]);
      
      if (allBranchIds.size > 0) {
        allBranchIds.forEach(branchId => {
          const branch = branches.find(b => b.id === branchId);
          const minVal = stok.branch_min_usage?.[branchId] || '-';
          const maxVal = stok.branch_max_usage?.[branchId] || '-';
          
          if (minVal !== '-' || maxVal !== '-') {
            data.push({
              'Seviye': `  └ ${branch?.name || branchId}`,
              'Ürün Adı': '',
              'Model': `Min: ${minVal}`,
              'Birim': `Max: ${maxVal}`,
              'Ekleyen': '',
              'Tarih': ''
            });
          }
        });
      }
      
      // Boş satır ayırıcı
      data.push({
        'Seviye': '',
        'Ürün Adı': '',
        'Model': '',
        'Birim': '',
        'Ekleyen': '',
        'Tarih': ''
      });
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stok Kartları');
    
    // Kolon genişlikleri
    ws['!cols'] = [
      { wch: 20 }, // Seviye
      { wch: 30 }, // Ürün Adı
      { wch: 15 }, // Model / Min
      { wch: 12 }, // Birim / Max
      { wch: 15 }, // Ekleyen
      { wch: 12 }  // Tarih
    ];

    XLSX.writeFile(wb, `Stok_Kartlari_Detayli_${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Stok kartları detaylı Excel olarak indirildi');
  };

  // Cari Hesaba ait stok girişlerini çek
  // Cari Hesaba ait tüm hareketleri (giriş + çıkış) çek
  const fetchCariHareketler = async (cariId, cariName) => {
    setCariGirislerLoading(prev => ({ ...prev, [cariId]: true }));
    try {
      // Hem girişleri hem çıkışları çek
      const [girisRes, cikisRes] = await Promise.all([
        fetch(`${API}/api/global/stok-girisleri?cari_hesap_name=${encodeURIComponent(cariName)}`, { headers }),
        fetch(`${API}/api/global/stok-cikislari?cari_hesap_name=${encodeURIComponent(cariName)}`, { headers })
      ]);
      
      let hareketler = [];
      
      if (girisRes.ok) {
        const girisler = await girisRes.json();
        girisler.forEach(g => {
          hareketler.push({
            ...g,
            hareket_type: 'giriş',
            hareket_label: 'GİRİŞ'
          });
        });
      }
      
      if (cikisRes.ok) {
        const cikislar = await cikisRes.json();
        cikislar.forEach(c => {
          hareketler.push({
            id: c.id,
            branch_id: c.branch_id,
            branch_name: c.branch_name || '-',
            product_name: c.product_name,
            quantity: c.quantity,
            unit: c.unit || 'adet',
            unit_price: c.unit_price || 0,
            cari_hesap_name: c.cari_hesap_name || c.recipient_company || '-',
            description: c.description || '-',
            created_by_name: c.created_by_name || '-',
            created_at: c.created_at,
            hareket_type: 'çıkış',
            hareket_label: 'ÇIKIŞ'
          });
        });
      }
      
      // Tarihe göre sırala (en yeni en üstte)
      hareketler.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      
      setCariGirisler(prev => ({ ...prev, [cariId]: hareketler }));
    } catch (error) {
      console.error('Cari hareketleri yüklenirken hata:', error);
      toast.error('Hareketler yüklenemedi');
    } finally {
      setCariGirislerLoading(prev => ({ ...prev, [cariId]: false }));
    }
  };

  const toggleCariExpansion = (cariId, cariName) => {
    setExpandedCari(prev => {
      const isExpanded = prev[cariId];
      if (!isExpanded) {
        // Genişletiliyorsa tüm hareketleri çek
        fetchCariHareketler(cariId, cariName);
      }
      return { ...prev, [cariId]: !isExpanded };
    });
  };

  // Cari hareketlerini filtrele
  const getFilteredCariHareketler = (hareketler) => {
    if (!hareketler) return [];
    return hareketler.filter(h => {
      // Şube filtresi
      if (cariFilterBranch && h.branch_id !== cariFilterBranch) return false;
      // Giriş/Çıkış filtresi
      if (cariFilterType && h.hareket_type !== cariFilterType) return false;
      return true;
    });
  };

  // Stok hareketlerini filtrele
  const getFilteredStokMovements = (movements) => {
    if (!movements) return [];
    let filtered = movements.filter(m => {
      // Şube filtresi
      if (stokFilterBranch) {
        const branchMatch = branches.find(b => b.id === stokFilterBranch);
        if (branchMatch && m.branch !== branchMatch.name) return false;
      }
      // Giriş/Çıkış filtresi
      if (stokFilterType && m.type !== stokFilterType) return false;
      return true;
    });
    return getSortedMovements(filtered);
  };

  return (
    <div className="space-y-6" data-testid="purchasing-global-data">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Cari Hesap & Stok Kartı</h1>
          <p className="text-sm text-gray-500 mt-1">Tüm şubeler tarafından ortak kullanılan veriler</p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 max-w-md">
          <TabsTrigger value="cari" className="gap-2" data-testid="tab-cari">
            <Building2 className="h-4 w-4" />
            Cari Hesaplar ({cariHesaplar.length})
          </TabsTrigger>
          <TabsTrigger value="stok" className="gap-2" data-testid="tab-stok">
            <Package className="h-4 w-4" />
            Stok Kartları ({stokKartlari.length})
          </TabsTrigger>
        </TabsList>

        {/* Cari Hesaplar Tab */}
        <TabsContent value="cari" className="mt-6">
          <InfoBanner id="purchasing-cari-hesaplar-info" variant="info">
            Cari Hesap bölümünde ürün tedariği için çalışılan firmaların listesi bulunmaktadır. 
            Bu listedeki firmaların isimlerine tıklayınca firmalarla yapılan ürün tedariklerinin içeriğine erişebilirsiniz. 
            Kontrollerinizi buradan kolayca sağlayabilirsiniz.
          </InfoBanner>
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle className="flex items-center gap-2">
                <Building2 className="h-5 w-5 text-orange-600" />
                Cari Hesaplar
              </CardTitle>
              <div className="flex items-center gap-3">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    placeholder="Cari hesap ara..."
                    value={cariSearch}
                    onChange={(e) => setCariSearch(e.target.value)}
                    className="pl-10 w-64"
                    data-testid="cari-search"
                  />
                </div>
                <Button 
                  variant="outline" 
                  onClick={exportCariToExcel} 
                  className="gap-2"
                  disabled={filteredCari.length === 0}
                  data-testid="export-cari-btn"
                >
                  <Download className="h-4 w-4" />
                  Excel İndir
                </Button>
                {selectedCariItems.length > 0 && (
                  <>
                    <span className="text-sm text-gray-600">{selectedCariItems.length} seçildi</span>
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={handleBulkDeleteCari}
                      disabled={bulkDeleteLoading}
                    >
                      {bulkDeleteLoading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Trash2 className="h-4 w-4 mr-2" />}
                      Seçilenleri Sil
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => setSelectedCariItems([])}
                    >
                      Temizle
                    </Button>
                  </>
                )}
                <Button onClick={() => setCariModal(true)} className="gap-2 bg-orange-600 hover:bg-orange-700" data-testid="add-cari-btn">
                  <Plus className="h-4 w-4" />
                  Yeni Cari Hesap
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {cariLoading ? (
                <div className="text-center py-8 text-gray-500">Yükleniyor...</div>
              ) : filteredCari.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  {cariSearch ? 'Arama sonucu bulunamadı' : 'Henüz cari hesap eklenmemiş'}
                </div>
              ) : (
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="w-12">
                        <Checkbox 
                          checked={filteredCari.length > 0 && filteredCari.every(c => selectedCariItems.includes(c.id))}
                          onCheckedChange={() => toggleSelectAllCari(filteredCari)}
                        />
                      </TableHead>
                      <TableHead className="w-10"></TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleCariSort('name')}
                      >
                        <div className="flex items-center gap-1">
                          Cari Hesap Adı
                          <ArrowUpDown className={`h-4 w-4 ${cariSort.field === 'name' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleCariSort('city')}
                      >
                        <div className="flex items-center gap-1">
                          Şehir
                          <ArrowUpDown className={`h-4 w-4 ${cariSort.field === 'city' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead>Telefon</TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleCariSort('order_count')}
                      >
                        <div className="flex items-center gap-1">
                          Sipariş Sayısı
                          <ArrowUpDown className={`h-4 w-4 ${cariSort.field === 'order_count' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleCariSort('total_items')}
                      >
                        <div className="flex items-center gap-1">
                          Toplam Ürün
                          <ArrowUpDown className={`h-4 w-4 ${cariSort.field === 'total_items' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleCariSort('total_amount')}
                      >
                        <div className="flex items-center gap-1">
                          Toplam Tutar
                          <ArrowUpDown className={`h-4 w-4 ${cariSort.field === 'total_amount' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead className="text-center">İşlemler</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {filteredCari.map((cari) => (
                      <React.Fragment key={cari.id}>
                        <TableRow 
                          data-testid={`cari-row-${cari.id}`}
                          className={`cursor-pointer hover:bg-gray-50 ${expandedCari[cari.id] ? 'bg-orange-50' : ''} ${selectedCariItems.includes(cari.id) ? 'bg-red-50' : ''}`}
                        >
                          <TableCell className="w-12" onClick={(e) => e.stopPropagation()}>
                            <Checkbox 
                              checked={selectedCariItems.includes(cari.id)}
                              onCheckedChange={() => toggleCariSelection(cari.id)}
                            />
                          </TableCell>
                          <TableCell className="w-10" onClick={() => toggleCariExpansion(cari.id, cari.name)}>
                            {expandedCari[cari.id] ? (
                              <ChevronDown className="h-4 w-4 text-orange-600" />
                            ) : (
                              <ChevronRight className="h-4 w-4 text-gray-400" />
                            )}
                          </TableCell>
                          <TableCell className="font-medium" onClick={() => toggleCariExpansion(cari.id, cari.name)}>
                            <div className="flex items-center gap-2">
                              <Building2 className="h-4 w-4 text-gray-400" />
                              {cari.name}
                            </div>
                          </TableCell>
                          <TableCell onClick={() => toggleCariExpansion(cari.id, cari.name)}>
                            <div className="flex items-center gap-1 text-gray-600">
                              <MapPin className="h-3 w-3" />
                              {cari.city || '-'}
                            </div>
                          </TableCell>
                          <TableCell onClick={() => toggleCariExpansion(cari.id, cari.name)}>
                            <div className="flex items-center gap-1 text-gray-600">
                              <Phone className="h-3 w-3" />
                              {cari.phone || '-'}
                            </div>
                          </TableCell>
                          <TableCell>
                            {cari.order_count > 0 ? (
                              <Badge className="bg-blue-100 text-blue-700">
                                {cari.order_count} sipariş
                              </Badge>
                            ) : (
                              <span className="text-gray-400">-</span>
                            )}
                          </TableCell>
                          <TableCell>
                            {cari.total_items > 0 ? (
                              <Badge className="bg-purple-100 text-purple-700">
                                {cari.total_items} ürün
                              </Badge>
                            ) : (
                              <span className="text-gray-400">-</span>
                            )}
                          </TableCell>
                          <TableCell>
                            {cari.total_spent > 0 ? (
                              <span className="font-semibold text-emerald-600">
                                {formatCurrency(cari.total_spent)}
                              </span>
                            ) : (
                              <span className="text-gray-400">-</span>
                            )}
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center justify-center gap-1">
                              <Button
                                variant="ghost"
                                size="sm"
                                className="h-8 w-8 p-0 text-blue-600 hover:text-blue-800 hover:bg-blue-50"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedCari(cari);
                                  setCariDetailModal(true);
                                }}
                                title="Detay Görüntüle"
                              >
                                <Eye className="h-4 w-4" />
                              </Button>
                              <Button
                                variant="ghost"
                                size="sm"
                                className="h-8 w-8 p-0 text-orange-600 hover:text-orange-800 hover:bg-orange-50"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setEditCariForm({
                                    id: cari.id,
                                    name: cari.name || '',
                                    city: cari.city || '',
                                    phone: cari.phone || '',
                                    vergi_no: cari.vergi_no || '',
                                    yetkili: cari.yetkili || '',
                                    adres: cari.adres || '',
                                    email: cari.email || '',
                                    iban: cari.iban || '',
                                    hesap_sahibi: cari.hesap_sahibi || ''
                                  });
                                  setEditCariModal(true);
                                }}
                                title="Düzenle"
                              >
                                <Pencil className="h-4 w-4" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                        
                        {/* Expanded Stock Entries Row */}
                        {expandedCari[cari.id] && (
                          <TableRow className="bg-gray-50">
                            <TableCell colSpan={9} className="p-0">
                              <div className="p-4 border-l-4 border-orange-400">
                                {cariGirislerLoading[cari.id] ? (
                                  <div className="flex items-center justify-center py-8">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600"></div>
                                    <span className="ml-3 text-gray-600">Yükleniyor...</span>
                                  </div>
                                ) : cariGirisler[cari.id] && cariGirisler[cari.id].length > 0 ? (
                                  <>
                                    {/* Filtreler */}
                                    <div className="flex items-center justify-between mb-4">
                                      <div className="text-xs font-semibold text-gray-500 flex items-center gap-2">
                                        <TrendingUp className="h-4 w-4" />
                                        STOK HAREKETLERİ ({getFilteredCariHareketler(cariGirisler[cari.id]).length} / {cariGirisler[cari.id].length} kayıt)
                                      </div>
                                      <div className="flex items-center gap-3">
                                        {/* Şube Filtresi */}
                                        <div className="flex items-center gap-2">
                                          <label className="text-xs text-gray-500">Şube:</label>
                                          <select
                                            value={cariFilterBranch}
                                            onChange={(e) => setCariFilterBranch(e.target.value)}
                                            className="text-xs border border-gray-300 rounded px-2 py-1 bg-white"
                                          >
                                            <option value="">Tümü</option>
                                            {branches.map(b => (
                                              <option key={b.id} value={b.id}>{b.name}</option>
                                            ))}
                                          </select>
                                        </div>
                                        {/* Giriş/Çıkış Filtresi */}
                                        <div className="flex items-center gap-2">
                                          <label className="text-xs text-gray-500">Hareket:</label>
                                          <select
                                            value={cariFilterType}
                                            onChange={(e) => setCariFilterType(e.target.value)}
                                            className="text-xs border border-gray-300 rounded px-2 py-1 bg-white"
                                          >
                                            <option value="">Tümü</option>
                                            <option value="giriş">Giriş</option>
                                            <option value="çıkış">Çıkış</option>
                                          </select>
                                        </div>
                                        {/* Filtreleri Temizle */}
                                        {(cariFilterBranch || cariFilterType) && (
                                          <Button
                                            variant="ghost"
                                            size="sm"
                                            onClick={() => { setCariFilterBranch(''); setCariFilterType(''); }}
                                            className="text-xs h-7 px-2"
                                          >
                                            Temizle
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                    <Table>
                                      <TableHeader>
                                        <TableRow className="bg-gray-100">
                                          <TableHead className="text-xs">Tarih</TableHead>
                                          <TableHead className="text-xs">Tip</TableHead>
                                          <TableHead className="text-xs">Ürün</TableHead>
                                          <TableHead className="text-xs">Miktar</TableHead>
                                          <TableHead className="text-xs">Birim</TableHead>
                                          <TableHead className="text-xs">Birim Fiyat</TableHead>
                                          <TableHead className="text-xs">Toplam</TableHead>
                                          <TableHead className="text-xs">Şube</TableHead>
                                          <TableHead className="text-xs">Açıklama</TableHead>
                                        </TableRow>
                                      </TableHeader>
                                      <TableBody>
                                        {getFilteredCariHareketler(cariGirisler[cari.id]).map((giris, idx) => {
                                          const miktar = parseFloat(giris.quantity || 0);
                                          const birimFiyat = parseFloat(giris.unit_price || 0);
                                          const toplam = miktar * birimFiyat;
                                          return (
                                            <TableRow key={idx} className="hover:bg-gray-100">
                                              <TableCell className="text-sm">
                                                <div className="flex items-center gap-1">
                                                  <Calendar className="h-3 w-3 text-gray-400" />
                                                  {formatDateTime(giris.created_at)}
                                                </div>
                                              </TableCell>
                                              <TableCell className="text-sm">
                                                <Badge className={giris.hareket_type === 'giriş' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}>
                                                  {giris.hareket_label || 'GİRİŞ'}
                                                </Badge>
                                              </TableCell>
                                              <TableCell className="text-sm font-medium">
                                                {giris.product_name || '-'}
                                              </TableCell>
                                              <TableCell className="text-sm">
                                                <Badge className="bg-blue-100 text-blue-700">
                                                  {miktar}
                                                </Badge>
                                              </TableCell>
                                              <TableCell className="text-sm text-gray-600">
                                                {giris.unit || 'adet'}
                                              </TableCell>
                                              <TableCell className="text-sm">
                                                {birimFiyat > 0 ? formatCurrency(birimFiyat) : '-'}
                                              </TableCell>
                                              <TableCell className="text-sm font-semibold text-emerald-600">
                                                {toplam > 0 ? formatCurrency(toplam) : '-'}
                                              </TableCell>
                                              <TableCell className="text-sm text-gray-600">
                                                {giris.branch_name || '-'}
                                              </TableCell>
                                              <TableCell className="text-sm text-gray-600 max-w-xs truncate">
                                                {giris.description || '-'}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                      </TableBody>
                                    </Table>
                                    {/* Toplam özeti */}
                                    <div className="mt-4 pt-3 border-t border-gray-200 flex justify-end gap-6">
                                      <div className="text-sm">
                                        <span className="text-gray-500">Gösterilen:</span>
                                        <span className="ml-2 font-semibold">{getFilteredCariHareketler(cariGirisler[cari.id]).length} kayıt</span>
                                      </div>
                                      <div className="text-sm">
                                        <span className="text-gray-500">Toplam Tutar:</span>
                                        <span className="ml-2 font-semibold text-emerald-600">
                                          {formatCurrency(getFilteredCariHareketler(cariGirisler[cari.id]).reduce((sum, g) => sum + (parseFloat(g.quantity || 0) * parseFloat(g.unit_price || 0)), 0))}
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div className="text-center py-8 text-gray-500">
                                    <Package className="h-12 w-12 mx-auto mb-3 text-gray-300" />
                                    <p>Bu cari hesaba ait stok hareketi bulunamadı.</p>
                                  </div>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Stok Kartları Tab */}
        <TabsContent value="stok" className="mt-6">
          <InfoBanner id="purchasing-stok-kartlari-info" variant="info">
            Stok Kartları bölümünde yeni stok kartları ekleyebilirsiniz. 
            Eklediğiniz stok kartlarının depo stokları içinde nasıl hareket ettiğini görebilirsiniz. 
            Kontrollerinizi buradan kolayca sağlayabilirsiniz.
          </InfoBanner>
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle className="flex items-center gap-2">
                <Package className="h-5 w-5 text-orange-600" />
                Stok Kartları
              </CardTitle>
              <div className="flex items-center gap-3">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    placeholder="Stok kartı ara..."
                    value={stokSearch}
                    onChange={(e) => setStokSearch(e.target.value)}
                    className="pl-10 w-64"
                    data-testid="stok-search"
                  />
                </div>
                <Button 
                  variant="outline" 
                  onClick={exportStokToExcel} 
                  className="gap-2"
                  disabled={filteredStok.length === 0}
                  data-testid="export-stok-btn"
                >
                  <Download className="h-4 w-4" />
                  Excel İndir
                </Button>
                {selectedStokItems.length > 0 && (
                  <>
                    <span className="text-sm text-gray-600">{selectedStokItems.length} seçildi</span>
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={handleBulkDeleteStok}
                      disabled={bulkDeleteLoading}
                    >
                      {bulkDeleteLoading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Trash2 className="h-4 w-4 mr-2" />}
                      Seçilenleri Sil
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => setSelectedStokItems([])}
                    >
                      Temizle
                    </Button>
                  </>
                )}
                <Button onClick={() => setStokModal(true)} className="gap-2 bg-orange-600 hover:bg-orange-700" data-testid="add-stok-btn">
                  <Plus className="h-4 w-4" />
                  Yeni Stok Kartı
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {stokLoading ? (
                <div className="text-center py-8 text-gray-500">Yükleniyor...</div>
              ) : filteredStok.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  {stokSearch ? 'Arama sonucu bulunamadı' : 'Henüz stok kartı eklenmemiş'}
                </div>
              ) : (
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="w-12">
                        <Checkbox 
                          checked={filteredStok.length > 0 && filteredStok.every(s => selectedStokItems.includes(s.id))}
                          onCheckedChange={() => toggleSelectAllStok(filteredStok)}
                        />
                      </TableHead>
                      <TableHead className="w-10"></TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleStokSort('product_name')}
                      >
                        <div className="flex items-center gap-1">
                          Ürün Adı
                          <ArrowUpDown className={`h-4 w-4 ${stokSort.field === 'product_name' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleStokSort('model')}
                      >
                        <div className="flex items-center gap-1">
                          Model
                          <ArrowUpDown className={`h-4 w-4 ${stokSort.field === 'model' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleStokSort('unit')}
                      >
                        <div className="flex items-center gap-1">
                          Birim
                          <ArrowUpDown className={`h-4 w-4 ${stokSort.field === 'unit' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead>Min. Stok</TableHead>
                      <TableHead>Max. Alım</TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleStokSort('created_by_name')}
                      >
                        <div className="flex items-center gap-1">
                          Ekleyen
                          <ArrowUpDown className={`h-4 w-4 ${stokSort.field === 'created_by_name' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead 
                        className="cursor-pointer hover:bg-gray-100"
                        onClick={() => handleStokSort('created_at')}
                      >
                        <div className="flex items-center gap-1">
                          Tarih
                          <ArrowUpDown className={`h-4 w-4 ${stokSort.field === 'created_at' ? 'text-orange-600' : 'text-gray-400'}`} />
                        </div>
                      </TableHead>
                      <TableHead className="text-center">İşlemler</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {filteredStok.map((stok) => (
                      <Fragment key={stok.id}>
                        <TableRow 
                          className={`cursor-pointer hover:bg-orange-50 transition-colors ${selectedStokItems.includes(stok.id) ? 'bg-red-50' : ''}`}
                          data-testid={`stok-row-${stok.id}`}
                        >
                          <TableCell className="w-12" onClick={(e) => e.stopPropagation()}>
                            <Checkbox 
                              checked={selectedStokItems.includes(stok.id)}
                              onCheckedChange={() => toggleStokSelection(stok.id)}
                            />
                          </TableCell>
                          <TableCell className="w-10" onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>
                            {expandedStok[stok.id] ? (
                              <ChevronDown className="h-4 w-4 text-orange-600" />
                            ) : (
                              <ChevronRight className="h-4 w-4 text-gray-400" />
                            )}
                          </TableCell>
                          <TableCell className="font-medium" onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>
                            <div className="flex items-center gap-2">
                              <Package className="h-4 w-4 text-gray-400" />
                              {stok.product_name}
                            </div>
                          </TableCell>
                          <TableCell onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>{stok.model || '-'}</TableCell>
                          <TableCell onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>{stok.unit}</TableCell>
                          <TableCell onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>
                            <div className="flex flex-wrap gap-1">
                              {stok.branch_min_usage && Object.keys(stok.branch_min_usage).length > 0 ? (
                                Object.entries(stok.branch_min_usage).map(([branchId, value]) => {
                                  const branch = branches.find(b => b.id === branchId);
                                  return value ? (
                                    <Badge key={branchId} variant="outline" className="text-xs">
                                      {branch?.name?.substring(0, 3) || branchId.substring(0, 3)}: {value}
                                    </Badge>
                                  ) : null;
                                })
                              ) : (
                                <span className="text-gray-400">-</span>
                              )}
                            </div>
                          </TableCell>
                          <TableCell onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>
                            <div className="flex flex-wrap gap-1">
                              {stok.branch_max_usage && Object.keys(stok.branch_max_usage).length > 0 ? (
                                Object.entries(stok.branch_max_usage).map(([branchId, value]) => {
                                  const branch = branches.find(b => b.id === branchId);
                                  return value ? (
                                    <Badge key={branchId} variant="outline" className="text-xs bg-orange-50">
                                      {branch?.name?.substring(0, 3) || branchId.substring(0, 3)}: {value}
                                    </Badge>
                                  ) : null;
                                })
                              ) : (
                                <span className="text-gray-400">-</span>
                              )}
                            </div>
                          </TableCell>
                          <TableCell onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>
                            <div className="flex items-center gap-1 text-gray-600">
                              <User className="h-3 w-3" />
                              {stok.created_by_name || '-'}
                            </div>
                          </TableCell>
                          <TableCell onClick={() => toggleStokExpansion(stok.id, stok.product_name)}>
                            <div className="flex items-center gap-1 text-gray-600">
                              <Calendar className="h-3 w-3" />
                              {formatDate(stok.created_at)}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center justify-center gap-1">
                              <Button
                                variant="ghost"
                                size="sm"
                                className="h-8 w-8 p-0 text-orange-600 hover:text-orange-800 hover:bg-orange-50"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setEditStokForm({
                                    id: stok.id,
                                    product_name: stok.product_name || '',
                                    model: stok.model || '',
                                    unit: stok.unit || '',
                                    min_stock_level: stok.min_stock_level || '',
                                    max_purchase_limit: stok.max_purchase_limit || '',
                                    branch_min_usage: stok.branch_min_usage || {},
                                    branch_max_usage: stok.branch_max_usage || {}
                                  });
                                  setEditStokModal(true);
                                }}
                                title="Düzenle"
                              >
                                <Pencil className="h-4 w-4" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                        
                        {/* Genişletilmiş Stok Hareketleri Satırı */}
                        {expandedStok[stok.id] && (
                          <TableRow>
                            <TableCell colSpan={9} className="bg-gray-50 p-0">
                              <div className="p-4">
                                <div className="flex items-center justify-between mb-3">
                                  <div className="flex items-center gap-2">
                                    <TrendingUp className="h-5 w-5 text-orange-600" />
                                    <h4 className="font-semibold text-gray-800">
                                      {stok.product_name} - Stok Hareketleri
                                    </h4>
                                    {stokMovements[stok.id] && (
                                      <Badge variant="secondary" className="ml-2">
                                        {getFilteredStokMovements(stokMovements[stok.id]).length} / {stokMovements[stok.id].length} hareket
                                      </Badge>
                                    )}
                                  </div>
                                  {/* Stok Filtreler */}
                                  <div className="flex items-center gap-3">
                                    {/* Şube Filtresi */}
                                    <div className="flex items-center gap-2">
                                      <label className="text-xs text-gray-500">Şube:</label>
                                      <select
                                        value={stokFilterBranch}
                                        onChange={(e) => setStokFilterBranch(e.target.value)}
                                        className="text-xs border border-gray-300 rounded px-2 py-1 bg-white"
                                      >
                                        <option value="">Tümü</option>
                                        {branches.map(b => (
                                          <option key={b.id} value={b.id}>{b.name}</option>
                                        ))}
                                      </select>
                                    </div>
                                    {/* Giriş/Çıkış Filtresi */}
                                    <div className="flex items-center gap-2">
                                      <label className="text-xs text-gray-500">Hareket:</label>
                                      <select
                                        value={stokFilterType}
                                        onChange={(e) => setStokFilterType(e.target.value)}
                                        className="text-xs border border-gray-300 rounded px-2 py-1 bg-white"
                                      >
                                        <option value="">Tümü</option>
                                        <option value="giriş">Giriş</option>
                                        <option value="çıkış">Çıkış</option>
                                      </select>
                                    </div>
                                    {/* Filtreleri Temizle */}
                                    {(stokFilterBranch || stokFilterType) && (
                                      <Button
                                        variant="ghost"
                                        size="sm"
                                        onClick={() => { setStokFilterBranch(''); setStokFilterType(''); }}
                                        className="text-xs h-7 px-2"
                                      >
                                        Temizle
                                      </Button>
                                    )}
                                  </div>
                                </div>
                                
                                {stokMovementsLoading[stok.id] ? (
                                  <div className="text-center py-4 text-gray-500">
                                    Yükleniyor...
                                  </div>
                                ) : stokMovements[stok.id]?.length === 0 ? (
                                  <div className="text-center py-4 text-gray-500">
                                    Bu ürün için stok hareketi bulunamadı
                                  </div>
                                ) : getFilteredStokMovements(stokMovements[stok.id]).length === 0 ? (
                                  <div className="text-center py-4 text-gray-500">
                                    Seçilen filtrelere uygun stok hareketi bulunamadı
                                  </div>
                                ) : (
                                  <div className="border rounded-lg overflow-hidden bg-white">
                                    <Table>
                                      <TableHeader>
                                        <TableRow className="bg-gray-100">
                                          <TableHead 
                                            className="cursor-pointer hover:bg-gray-200"
                                            onClick={(e) => { e.stopPropagation(); handleMovementSort('date'); }}
                                          >
                                            <div className="flex items-center gap-1">
                                              Tarih
                                              <ArrowUpDown className={`h-3 w-3 ${movementSort.field === 'date' ? 'text-orange-600' : 'text-gray-400'}`} />
                                            </div>
                                          </TableHead>
                                          <TableHead 
                                            className="cursor-pointer hover:bg-gray-200"
                                            onClick={(e) => { e.stopPropagation(); handleMovementSort('type'); }}
                                          >
                                            <div className="flex items-center gap-1">
                                              Hareket
                                              <ArrowUpDown className={`h-3 w-3 ${movementSort.field === 'type' ? 'text-orange-600' : 'text-gray-400'}`} />
                                            </div>
                                          </TableHead>
                                          <TableHead 
                                            className="cursor-pointer hover:bg-gray-200"
                                            onClick={(e) => { e.stopPropagation(); handleMovementSort('quantity'); }}
                                          >
                                            <div className="flex items-center gap-1">
                                              Miktar
                                              <ArrowUpDown className={`h-3 w-3 ${movementSort.field === 'quantity' ? 'text-orange-600' : 'text-gray-400'}`} />
                                            </div>
                                          </TableHead>
                                          <TableHead>Birim</TableHead>
                                          <TableHead 
                                            className="cursor-pointer hover:bg-gray-200"
                                            onClick={(e) => { e.stopPropagation(); handleMovementSort('source'); }}
                                          >
                                            <div className="flex items-center gap-1">
                                              Kaynak/Hedef
                                              <ArrowUpDown className={`h-3 w-3 ${movementSort.field === 'source' ? 'text-orange-600' : 'text-gray-400'}`} />
                                            </div>
                                          </TableHead>
                                          <TableHead 
                                            className="cursor-pointer hover:bg-gray-200"
                                            onClick={(e) => { e.stopPropagation(); handleMovementSort('branch'); }}
                                          >
                                            <div className="flex items-center gap-1">
                                              Şube
                                              <ArrowUpDown className={`h-3 w-3 ${movementSort.field === 'branch' ? 'text-orange-600' : 'text-gray-400'}`} />
                                            </div>
                                          </TableHead>
                                          <TableHead>Açıklama</TableHead>
                                          <TableHead>İşlemi Yapan</TableHead>
                                        </TableRow>
                                      </TableHeader>
                                      <TableBody>
                                        {getFilteredStokMovements(stokMovements[stok.id]).map((movement) => (
                                          <TableRow key={movement.id} className="hover:bg-gray-50">
                                            <TableCell className="text-sm">
                                              {formatDate(movement.date)}
                                            </TableCell>
                                            <TableCell>
                                              <Badge 
                                                variant={movement.type === 'giriş' ? 'default' : 'destructive'}
                                                className={movement.type === 'giriş' ? 'bg-green-500 hover:bg-green-600' : 'bg-red-500 hover:bg-red-600'}
                                              >
                                                {movement.type === 'giriş' ? '↑ Giriş' : '↓ Çıkış'}
                                              </Badge>
                                            </TableCell>
                                            <TableCell className={`font-semibold ${movement.type === 'giriş' ? 'text-green-600' : 'text-red-600'}`}>
                                              {movement.type === 'giriş' ? '+' : '-'}{movement.quantity}
                                            </TableCell>
                                            <TableCell className="text-sm">{movement.unit}</TableCell>
                                            <TableCell className="text-sm">{movement.source}</TableCell>
                                            <TableCell className="text-sm">{movement.branch}</TableCell>
                                            <TableCell className="text-sm text-gray-600 max-w-xs truncate">
                                              {movement.description}
                                            </TableCell>
                                            <TableCell className="text-sm text-gray-600">
                                              {movement.created_by}
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </div>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </Fragment>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Cari Hesap Ekle Modal */}
      <Dialog open={cariModal} onOpenChange={setCariModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Building2 className="h-5 w-5 text-orange-600" />
              Yeni Cari Hesap Ekle
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
            <div>
              <Label htmlFor="cari-name">Cari Hesap Adı *</Label>
              <Input
                id="cari-name"
                value={cariForm.name}
                onChange={(e) => setCariForm({ ...cariForm, name: e.target.value })}
                placeholder="Firma adı"
                data-testid="cari-name-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-vergi-no">Vergi No</Label>
              <Input
                id="cari-vergi-no"
                value={cariForm.vergi_no}
                onChange={(e) => setCariForm({ ...cariForm, vergi_no: e.target.value })}
                placeholder="Vergi numarası"
                data-testid="cari-vergi-no-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-yetkili">Yetkili</Label>
              <Input
                id="cari-yetkili"
                value={cariForm.yetkili}
                onChange={(e) => setCariForm({ ...cariForm, yetkili: e.target.value })}
                placeholder="Yetkili kişi adı"
                data-testid="cari-yetkili-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-adres">Adres</Label>
              <Input
                id="cari-adres"
                value={cariForm.adres}
                onChange={(e) => setCariForm({ ...cariForm, adres: e.target.value })}
                placeholder="Firma adresi"
                data-testid="cari-adres-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-city">Şehir</Label>
              <Input
                id="cari-city"
                value={cariForm.city}
                onChange={(e) => setCariForm({ ...cariForm, city: e.target.value })}
                placeholder="Şehir"
                data-testid="cari-city-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-phone">Telefon</Label>
              <Input
                id="cari-phone"
                value={cariForm.phone}
                onChange={(e) => setCariForm({ ...cariForm, phone: e.target.value })}
                placeholder="Telefon numarası"
                data-testid="cari-phone-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-email">E-mail</Label>
              <Input
                id="cari-email"
                type="email"
                value={cariForm.email}
                onChange={(e) => setCariForm({ ...cariForm, email: e.target.value })}
                placeholder="E-posta adresi"
                data-testid="cari-email-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-iban">IBAN</Label>
              <Input
                id="cari-iban"
                value={cariForm.iban}
                onChange={(e) => setCariForm({ ...cariForm, iban: e.target.value })}
                placeholder="TR00 0000 0000 0000 0000 0000 00"
                data-testid="cari-iban-input"
              />
            </div>
            <div>
              <Label htmlFor="cari-hesap-sahibi">Hesap Sahibi</Label>
              <Input
                id="cari-hesap-sahibi"
                value={cariForm.hesap_sahibi}
                onChange={(e) => setCariForm({ ...cariForm, hesap_sahibi: e.target.value })}
                placeholder="Hesap sahibi adı"
                data-testid="cari-hesap-sahibi-input"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setCariModal(false)}>İptal</Button>
            <Button onClick={handleCreateCari} className="bg-orange-600 hover:bg-orange-700" data-testid="save-cari-btn">
              Kaydet
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Cari Hesap Düzenle Modal */}
      <Dialog open={editCariModal} onOpenChange={setEditCariModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Pencil className="h-5 w-5 text-orange-600" />
              Cari Hesap Düzenle
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
            <div>
              <Label htmlFor="edit-cari-name">Cari Hesap Adı *</Label>
              <Input
                id="edit-cari-name"
                value={editCariForm.name}
                onChange={(e) => setEditCariForm({ ...editCariForm, name: e.target.value })}
                placeholder="Firma adı"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-vergi-no">Vergi No</Label>
              <Input
                id="edit-cari-vergi-no"
                value={editCariForm.vergi_no || ''}
                onChange={(e) => setEditCariForm({ ...editCariForm, vergi_no: e.target.value })}
                placeholder="Vergi numarası"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-yetkili">Yetkili</Label>
              <Input
                id="edit-cari-yetkili"
                value={editCariForm.yetkili || ''}
                onChange={(e) => setEditCariForm({ ...editCariForm, yetkili: e.target.value })}
                placeholder="Yetkili kişi adı"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-adres">Adres</Label>
              <Input
                id="edit-cari-adres"
                value={editCariForm.adres || ''}
                onChange={(e) => setEditCariForm({ ...editCariForm, adres: e.target.value })}
                placeholder="Firma adresi"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-city">Şehir</Label>
              <Input
                id="edit-cari-city"
                value={editCariForm.city}
                onChange={(e) => setEditCariForm({ ...editCariForm, city: e.target.value })}
                placeholder="Şehir"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-phone">Telefon</Label>
              <Input
                id="edit-cari-phone"
                value={editCariForm.phone}
                onChange={(e) => setEditCariForm({ ...editCariForm, phone: e.target.value })}
                placeholder="Telefon numarası"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-email">E-mail</Label>
              <Input
                id="edit-cari-email"
                type="email"
                value={editCariForm.email || ''}
                onChange={(e) => setEditCariForm({ ...editCariForm, email: e.target.value })}
                placeholder="E-posta adresi"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-iban">IBAN</Label>
              <Input
                id="edit-cari-iban"
                value={editCariForm.iban || ''}
                onChange={(e) => setEditCariForm({ ...editCariForm, iban: e.target.value })}
                placeholder="TR00 0000 0000 0000 0000 0000 00"
              />
            </div>
            <div>
              <Label htmlFor="edit-cari-hesap-sahibi">Hesap Sahibi</Label>
              <Input
                id="edit-cari-hesap-sahibi"
                value={editCariForm.hesap_sahibi || ''}
                onChange={(e) => setEditCariForm({ ...editCariForm, hesap_sahibi: e.target.value })}
                placeholder="Hesap sahibi adı"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditCariModal(false)}>İptal</Button>
            <Button onClick={handleUpdateCari} className="bg-orange-600 hover:bg-orange-700">
              Güncelle
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Cari Hesap Kartı Detay Modal */}
      <Dialog open={cariDetailModal} onOpenChange={setCariDetailModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Building2 className="h-5 w-5 text-orange-600" />
              Cari Hesap Kartı
            </DialogTitle>
          </DialogHeader>
          {selectedCari && (
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6 border border-orange-200">
              {/* Firma Adı - Büyük başlık */}
              <div className="text-center mb-6 pb-4 border-b border-orange-200">
                <h2 className="text-2xl font-bold text-gray-800">{selectedCari.name}</h2>
                <p className="text-sm text-gray-500 mt-1">Cari Hesap</p>
              </div>
              
              {/* Detay Grid */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <FileText className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">Vergi No</span>
                  </div>
                  <p className="text-gray-800 font-medium">{selectedCari.vergi_no || '-'}</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <User className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">Yetkili</span>
                  </div>
                  <p className="text-gray-800 font-medium">{selectedCari.yetkili || '-'}</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm col-span-2">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <MapPin className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">Adres</span>
                  </div>
                  <p className="text-gray-800 font-medium">{selectedCari.adres || '-'}</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <MapPin className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">Şehir</span>
                  </div>
                  <p className="text-gray-800 font-medium">{selectedCari.city || '-'}</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <Phone className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">Telefon</span>
                  </div>
                  <p className="text-gray-800 font-medium">{selectedCari.phone || '-'}</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm col-span-2">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <Mail className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">E-mail</span>
                  </div>
                  <p className="text-gray-800 font-medium">{selectedCari.email || '-'}</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm col-span-2">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <CreditCard className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">IBAN</span>
                  </div>
                  <p className="text-gray-800 font-medium font-mono">{selectedCari.iban || '-'}</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm col-span-2">
                  <div className="flex items-center gap-2 text-orange-600 mb-1">
                    <User className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase">Hesap Sahibi</span>
                  </div>
                  <p className="text-gray-800 font-medium">{selectedCari.hesap_sahibi || '-'}</p>
                </div>
              </div>
              
              {/* Alt bilgi */}
              <div className="mt-6 pt-4 border-t border-orange-200 flex justify-between text-xs text-gray-500">
                <span>Ekleyen: {selectedCari.created_by_name || '-'}</span>
                <span>Tarih: {selectedCari.created_at ? formatDate(selectedCari.created_at) : '-'}</span>
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setCariDetailModal(false)}>Kapat</Button>
            <Button 
              onClick={() => {
                setEditCariForm({
                  id: selectedCari.id,
                  name: selectedCari.name || '',
                  city: selectedCari.city || '',
                  phone: selectedCari.phone || '',
                  vergi_no: selectedCari.vergi_no || '',
                  yetkili: selectedCari.yetkili || '',
                  adres: selectedCari.adres || '',
                  email: selectedCari.email || '',
                  iban: selectedCari.iban || '',
                  hesap_sahibi: selectedCari.hesap_sahibi || ''
                });
                setCariDetailModal(false);
                setEditCariModal(true);
              }}
              className="bg-orange-600 hover:bg-orange-700"
            >
              <Pencil className="h-4 w-4 mr-2" />
              Düzenle
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Stok Kartı Ekle Modal */}
      <Dialog open={stokModal} onOpenChange={(open) => {
        setStokModal(open);
        if (!open) {
          setStokForm({ 
            product_name: '', 
            model: '', 
            features: '', 
            unit: 'adet', 
            minimum_stock: '', 
            max_usage: '',
            branch_max_usage: {}
          });
        }
      }}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package className="h-5 w-5 text-orange-600" />
              Yeni Stok Kartı Ekle
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="stok-name">Ürün Adı *</Label>
              <Input
                id="stok-name"
                value={stokForm.product_name}
                onChange={(e) => setStokForm({ ...stokForm, product_name: e.target.value })}
                placeholder="Ürün adı"
                data-testid="stok-name-input"
              />
            </div>
            <div>
              <Label htmlFor="stok-model">Model</Label>
              <Input
                id="stok-model"
                value={stokForm.model}
                onChange={(e) => setStokForm({ ...stokForm, model: e.target.value })}
                placeholder="Model kodu"
                data-testid="stok-model-input"
              />
            </div>
            <div>
              <Label htmlFor="stok-features">Özellikler</Label>
              <Input
                id="stok-features"
                value={stokForm.features}
                onChange={(e) => setStokForm({ ...stokForm, features: e.target.value })}
                placeholder="Ürün özellikleri"
              />
            </div>
            <div>
              <Label htmlFor="stok-unit">Birim</Label>
              <select
                id="stok-unit"
                value={stokForm.unit}
                onChange={(e) => setStokForm({ ...stokForm, unit: e.target.value })}
                className="w-full rounded-md border border-gray-300 px-3 py-2"
                data-testid="stok-unit-select"
              >
                <option value="adet">Adet</option>
                <option value="kg">Kg</option>
                <option value="lt">Litre</option>
                <option value="mt">Metre</option>
                <option value="m2">m²</option>
                <option value="m3">m³</option>
                <option value="paket">Paket</option>
                <option value="kutu">Kutu</option>
                <option value="set">Set</option>
              </select>
            </div>
            
            {/* Şube Bazlı Min/Max Kullanım */}
            <div className="space-y-3">
              <Label className="flex items-center gap-2 text-orange-700">
                <Building2 className="h-4 w-4" />
                Şube Bazlı Min/Max Stok Değerleri
              </Label>
              <p className="text-xs text-gray-500">Her şubenin minimum ve maksimum stok miktarlarını belirleyin</p>
              <div className="border rounded-lg p-3 max-h-60 overflow-y-auto space-y-2 bg-gray-50">
                {branches.length === 0 ? (
                  <p className="text-sm text-gray-500 text-center py-2">Şube bulunamadı</p>
                ) : (
                  branches.map((branch) => (
                    <div key={branch.id} className="flex items-center justify-between gap-2 p-2 bg-white rounded border">
                      <span className="text-sm font-medium text-gray-700 flex-1 min-w-[100px]">{branch.name}</span>
                      <div className="flex items-center gap-2">
                        <div className="flex flex-col items-center">
                          <span className="text-xs text-gray-400">Min</span>
                          <Input
                            type="number"
                            min="0"
                            value={stokForm.branch_min_usage?.[branch.id] || ''}
                            onChange={(e) => setStokForm(prev => ({
                              ...prev,
                              branch_min_usage: {
                                ...prev.branch_min_usage,
                                [branch.id]: e.target.value
                              }
                            }))}
                            placeholder="0"
                            className="w-20 text-center"
                            data-testid={`branch-min-${branch.id}`}
                          />
                        </div>
                        <div className="flex flex-col items-center">
                          <span className="text-xs text-gray-400">Max</span>
                          <Input
                            type="number"
                            min="0"
                            value={stokForm.branch_max_usage?.[branch.id] || ''}
                            onChange={(e) => setStokForm(prev => ({
                              ...prev,
                              branch_max_usage: {
                                ...prev.branch_max_usage,
                                [branch.id]: e.target.value
                              }
                            }))}
                            placeholder="0"
                            className="w-20 text-center"
                            data-testid={`branch-max-${branch.id}`}
                          />
                        </div>
                        <span className="text-xs text-gray-500 w-10">{stokForm.unit || 'adet'}</span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setStokModal(false)}>İptal</Button>
            <Button onClick={handleCreateStok} className="bg-orange-600 hover:bg-orange-700" data-testid="save-stok-btn">
              Kaydet
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Stok Kartı Düzenle Modal */}
      <Dialog open={editStokModal} onOpenChange={setEditStokModal}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Pencil className="h-5 w-5 text-orange-600" />
              Stok Kartı Düzenle
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="edit-stok-name">Ürün Adı *</Label>
              <Input
                id="edit-stok-name"
                value={editStokForm.product_name}
                onChange={(e) => setEditStokForm({ ...editStokForm, product_name: e.target.value })}
                placeholder="Ürün adı"
              />
            </div>
            <div>
              <Label htmlFor="edit-stok-model">Model</Label>
              <Input
                id="edit-stok-model"
                value={editStokForm.model}
                onChange={(e) => setEditStokForm({ ...editStokForm, model: e.target.value })}
                placeholder="Model kodu"
              />
            </div>
            <div>
              <Label htmlFor="edit-stok-features">Özellikler</Label>
              <Input
                id="edit-stok-features"
                value={editStokForm.features}
                onChange={(e) => setEditStokForm({ ...editStokForm, features: e.target.value })}
                placeholder="Ürün özellikleri"
              />
            </div>
            <div>
              <Label htmlFor="edit-stok-unit">Birim</Label>
              <select
                id="edit-stok-unit"
                value={editStokForm.unit}
                onChange={(e) => setEditStokForm({ ...editStokForm, unit: e.target.value })}
                className="w-full rounded-md border border-gray-300 px-3 py-2"
              >
                <option value="adet">Adet</option>
                <option value="kg">Kg</option>
                <option value="lt">Litre</option>
                <option value="mt">Metre</option>
                <option value="m2">m²</option>
                <option value="m3">m³</option>
                <option value="paket">Paket</option>
                <option value="kutu">Kutu</option>
                <option value="set">Set</option>
              </select>
            </div>
            
            {/* Şube Bazlı Min/Max Kullanım */}
            <div className="space-y-3">
              <Label className="flex items-center gap-2 text-orange-700">
                <Building2 className="h-4 w-4" />
                Şube Bazlı Min/Max Stok Değerleri
              </Label>
              <p className="text-xs text-gray-500">Her şubenin minimum ve maksimum stok miktarlarını belirleyin</p>
              <div className="border rounded-lg p-3 max-h-60 overflow-y-auto space-y-2 bg-gray-50">
                {branches.length === 0 ? (
                  <p className="text-sm text-gray-500 text-center py-2">Şube bulunamadı</p>
                ) : (
                  branches.map((branch) => (
                    <div key={branch.id} className="flex items-center justify-between gap-2 p-2 bg-white rounded border">
                      <span className="text-sm font-medium text-gray-700 flex-1 min-w-[100px]">{branch.name}</span>
                      <div className="flex items-center gap-2">
                        <div className="flex flex-col items-center">
                          <span className="text-xs text-gray-400">Min</span>
                          <Input
                            type="number"
                            min="0"
                            value={editStokForm.branch_min_usage?.[branch.id] || ''}
                            onChange={(e) => setEditStokForm(prev => ({
                              ...prev,
                              branch_min_usage: {
                                ...prev.branch_min_usage,
                                [branch.id]: e.target.value
                              }
                            }))}
                            placeholder="0"
                            className="w-20 text-center"
                          />
                        </div>
                        <div className="flex flex-col items-center">
                          <span className="text-xs text-gray-400">Max</span>
                          <Input
                            type="number"
                            min="0"
                            value={editStokForm.branch_max_usage?.[branch.id] || ''}
                            onChange={(e) => setEditStokForm(prev => ({
                              ...prev,
                              branch_max_usage: {
                                ...prev.branch_max_usage,
                                [branch.id]: e.target.value
                              }
                            }))}
                            placeholder="0"
                            className="w-20 text-center"
                          />
                        </div>
                        <span className="text-xs text-gray-500 w-10">{editStokForm.unit || 'adet'}</span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditStokModal(false)}>İptal</Button>
            <Button onClick={handleUpdateStok} className="bg-orange-600 hover:bg-orange-700">
              Güncelle
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PurchasingGlobalData;
